export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10068.8d822f39.jpg";